module.exports = __webpack_public_path__ + "dc3693ee4b29eda86a638b5b791b2041.svg";